import _ from 'lodash'
import { read, readFile, utils } from 'xlsx'
import checkUtf8 from './isUtf8'

export const getImportJsonData = (file) => {
  return new Promise((resolve) => {
    const fileReader = new FileReader()
    fileReader.onload = async (event) => {
      try {
        const { result } = event.target
        const workbook = read(result, { type: 'binary' })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]
        const results = utils.sheet_to_json(worksheet)
        resolve(results)
      } catch (e) { console.log(e) }
    }
    fileReader.readAsBinaryString(file)
  })
}

export const readCsvToJsonLocation = (file, headerMatch, maxLength) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve) => {
    let type = 'utf8'
    const check = await checkUtf8(file)
    // --- check error ---
    if (!check.status) return resolve({ status: false, message: check.message })

    // --- check success ---
    if (check.type === 'big5') type = 'big5'
    const fileReader = new FileReader()
    fileReader.onload = async event => {
      try {
        const { result } = event.target
        const csvData = []
        const replaceBlank = result.includes('\r') ? result.replace(/\n/gi, '') : result
        const lineBreak = result.includes('\r') ? replaceBlank.split('\r') : replaceBlank.split('\n')
        lineBreak.forEach(data => data.includes('\t') ? csvData.push(data.split('\t')) : csvData.push(data.split(',')))
        const filterLine = csvData.filter((line) => line.find((item) => item))

        if (filterLine.length) {
          if (filterLine.length - 1 > maxLength) resolve({ status: false, message: 'message.error.dataExceedMaxLength' })
          else {
            const json = []
            const header = filterLine[0].map((item) => item.toLowerCase())
            const header2 = _.cloneDeep(header)
            const headerSort = header2.sort((a, b) => a < b ? 1 : -1)
            const match2 = _.cloneDeep(headerMatch?.map(i => i.toLowerCase()))
            const matchSort = match2.sort((a, b) => a < b ? 1 : -1)
            if (!_.isEqual(headerSort, matchSort)) resolve({ status: false, message: 'message.error.incorrectDataFormat' })
            else {
              for (let i = 1; i < filterLine.length; i++) {
                const n = Object.assign({}, ...filterLine[i].map((item, index) => ({ [`${header[index]}`]: item })))
                json.push(n)
              }
              resolve({ status: true, data: json })
            }
          }
        } else resolve({ status: false, message: 'message.error.noData' })
      } catch (e) { console.log(e) }
    }
    fileReader.readAsText(file, type)
  })
}

export const readCsvToJson = (file) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve) => {
    let type = 'utf8'
    const check = await checkUtf8(file)
    // --- check error ---
    if (!check.status) return resolve({ status: false, message: check.message })

    // --- check success ---
    if (check.type === 'big5') type = 'big5'
    const fileReader = new FileReader()
    fileReader.onload = async event => {
      try {
        const { result } = event.target
        const csvData = []
        const replaceBlank = result.includes('\r') ? result.replace(/\n/gi, '') : result
        const lineBreak = result.includes('\r') ? replaceBlank.split('\r') : replaceBlank.split('\n')
        lineBreak.forEach(data => data.includes('\t') ? csvData.push(data.split('\t')) : csvData.push(data.split(',')))
        const filterLine = csvData.filter((line) => line.find((item) => item))

        if (filterLine.length) {
          const json = []
          const header = filterLine[0]
          for (let i = 1; i < filterLine.length; i++) {
            const n = Object.assign({}, ...filterLine[i].map((item, index) => ({ [`${header[index]}`]: item })))
            json.push(n)
          }
          resolve({ status: true, data: json, header })
        } else resolve({ status: false, message: 'message.error.noData' })
      } catch (e) { console.log(e) }
    }
    fileReader.readAsText(file, type)
  })
}

export const readExcel = (filePath, Ce = -1, Cs = -1, column = undefined) => {
  const workbook = readFile(filePath)
  const sheetNames = workbook.SheetNames
  // Get the first workSheet
  const sheet1 = workbook.Sheets[sheetNames[0]]

  const range = utils.decode_range(sheet1['!ref'])

  if (Cs === -1) Cs = range.s.c // Column start from Cs
  if (Ce === -1) Ce = range.e.c // Column end at Ce

  // Get column array
  if (column === undefined) {
    column = []
    for (let C = Cs; C <= Ce; ++C) {
      const cell_address = { c: C, r: range.s.r }
      const cell = utils.encode_cell(cell_address)
      column.push(sheet1[cell].v)
    }
  }

  const inputJsonArray = []
  // Get each cell (column row when range.s.r == 0)
  for (let R = range.s.r + 1; R <= range.e.r; ++R) {
    const row_value_map = {}
    for (let C = Cs; C <= Ce; ++C) {
      const cell_address = { c: C, r: R } // Set cell location
      const cell = utils.encode_cell(cell_address) // Get cell location in excel, like B1
      // Get cell value
      row_value_map[column[C]] = sheet1[cell] ? sheet1[cell].v : ''
      // row_value_map[column[C]] = sheet1[cell] ? iconv.decode(sheet1[cell].v, 'gbk') : "";
    }
    const rowIsNotEmpty = (function () {
      for (const k in row_value_map) if (row_value_map[k] !== '') return true
      return false
    }())
    if (rowIsNotEmpty) inputJsonArray.push(row_value_map)
  }
  return inputJsonArray
}
